var DEFAULT_POLLING_INTERVAL = 250;
var DEFAULT_MAX_POLLING_TIME = 30 * 1000;

export { DEFAULT_MAX_POLLING_TIME, DEFAULT_POLLING_INTERVAL };
//# sourceMappingURL=constants.esm.js.map
